import React from 'react';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import { FormApi } from 'final-form';
import OwnerJointTenant from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenant';
import { AnyObject } from 'react-final-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import * as _ from 'lodash';

interface IJointTenantOwnerFormProps {
    handleOnSubmit: (formValues: OwnerJointTenant) => void;
    ownerData: LeaseGenerationOwnerData;
}

class JointTenantOwnerForm extends React.Component<IJointTenantOwnerFormProps> {
    private form: FormApi;
    componentDidMount() {
        this.form.reset();
    }

    validateForm = (values: AnyObject) => {
        const errors: AnyObject = {};
        if (!_.get(values, 'name')) {
            _.set(errors, 'name', 'Required');
        }
        return errors;
    };

    cleanUpForm = (formValues: AnyObject) => {
        const jtOwner = new OwnerJointTenant(formValues as OwnerJointTenant);
        this.props.handleOnSubmit(jtOwner);
    };

    jtOwners = () => {
        const ownerJointTenant = this.props.ownerData?.ownerDetails as OwnerJointTenant;
        if (ownerJointTenant?.tenantOwners.length > 0) {
            return ownerJointTenant.tenantOwners.map((tenant, index) => {
                return (
                    <div key={index}>
                        <div>
                            <FormTextBox name={`tenantOwners[${index}].prefix`} label="Prefix" className="lh-eighth-width" />
                            <FormTextBox name={`tenantOwners[${index}].firstName`} label="First Name" className="lh-fourth-width" isRequired={true} />
                            <FormTextBox
                                name={`tenantOwners[${index}].middleName`}
                                label="Middle Name"
                                className="lh-fourth-width"
                            />
                            <FormTextBox name={`tenantOwners[${index}].lastName`} label="Last Name" className="lh-fourth-width" />
                            <FormTextBox name={`tenantOwners[${index}].suffix`} label="Suffix" className="lh-eighth-width" />
                        </div>

                        <div>
                            <FormTextBox
                                name={`tenantOwners[${index}].addressLine1`}
                                label="Address Line 1"
                                className="lh-half-width"
                            />
                            <FormTextBox name={`tenantOwners[${index}].addressLine2`} label="Address Line 2" className="lh-half-width" />
                        </div>

                        <div>
                            <FormTextBox name={`tenantOwners[${index}].city`} label="City" className="lh-eighth-width" />
                            <FormTextBox name={`tenantOwners[${index}].state`} label="State" className="lh-eighth-width" />
                            <FormTextBox name={`tenantOwners[${index}].zipCode`} label="Zip Code" className="lh-eighth-width" />
                            <FormTextBox name={`tenantOwners[${index}].email`} label="Email" className="lh-eighth-width" />
                            <FormTextBox name={`tenantOwners[${index}].phone`} label="Phone" className="lh-eighth-width" />
                        </div>
                    </div>
                );
            });
        } else {
            return <div>no tenant owners</div>;
        }
    };

    public render() {
        console.log('ownerdatar', this.props.ownerData);
        return (
            <div style={{ margin: '1rem' }}>
                <h2>Joint Tenant Owner Form</h2>
                <Form
                    onSubmit={this.cleanUpForm}
                    style={{padding: '3rem'}}
                    initialValues={this.props.ownerData.ownerDetails}
                    onFormCreated={(form) => {
                        this.form = form;
                    }}
                >
                    <div>
                        <FormTextBox name="name" label="Joint Tenant Name" isRequired={true} className="lh-half-width" />
                        <FormTextBox name="ssnTaxId" label="SSN/Tax Id" className="lh-half-width" />
                    </div>

                    <div>
                        <FormTextBox name="addressLine1" label="Address Line 1" className="lh-half-width" />
                        <FormTextBox name="addressLine2" label="Address Line 2" className="lh-half-width" />
                    </div>

                    <div>
                        <FormTextBox name="city" label="City" className="lh-eighth-width" />
                        <FormTextBox name="state" label="State" className="lh-eighth-width" />
                        <FormTextBox name="zipCode" label="Zip Code" className="lh-eighth-width" />

                        <FormTextBox name="phoneNumber" label="Phone Number" className="lh-eighth-width" />
                        <FormTextBox name="email" label="Email" className="lh-eighth-width" />
                    </div>

                    {/* <div>
                        <div>Joint Tenant Owners</div>
                        <div>{this.jtOwners()}</div>
                    </div> */}

                    <div className="button-row">
                        <Button text="Save" type="submit" intent="primary" />
                    </div>
                </Form>
            </div>
        );
    }
}

export default JointTenantOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/JointTenantOwnerForm.tsx